import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "badges"]

  connect() {
    this.updateBadges()
  }

  selectAll() {
    const options = Array.from(this.selectTarget.options)
    options.forEach(option => {
      if (option.value !== "") {
        option.selected = true
      }
    })
    this.updateBadges()
  }

  unselectAll() {
    const options = Array.from(this.selectTarget.options)
    options.forEach(option => {
      option.selected = false
    })
    this.updateBadges()
  }

  updateBadges() {
    const selectedOptions = Array.from(this.selectTarget.selectedOptions)
      .filter(option => option.value !== "")

    if (selectedOptions.length === 0) {
      this.badgesTarget.innerHTML = '<span class="text-sm text-gray-400">No selection</span>'
      return
    }

    const badgesHTML = selectedOptions
      .map(option => {
        return `<span class="badge badge-sm badge-primary font-bold">${option.text}</span>`
      })
      .join('')

    this.badgesTarget.innerHTML = badgesHTML
  }
}
